import { useState } from 'react';

import { Center, Loader } from '@mantine/core';

import { useDisclosure, useMediaQuery } from '@mantine/hooks';

import { Menu } from 'lucide-react';

import NavbarComponent from './components/common/NavbarComponent';

import DrawerMenu from './components/common/DrawerMenu';

import { useAuth } from './contexts/AuthProvider';

import AppRoutes from './app/AppRouter';

import { HelpProvider } from './modules/help/HelpProvider';

import { useVersionCheck } from './shared/hooks/useVersionCheck';

export default function App() {
  useVersionCheck();
  const [opened, { toggle, close }] = useDisclosure();
  const [navbarPinnedOpen, { toggle: toggleNavbarPinned }] = useDisclosure(true);
  const [sidebarHovered, setSidebarHovered] = useState(false);
  const sidebarExpanded = navbarPinnedOpen || sidebarHovered;

  const isMobile = useMediaQuery('(max-width: 768px)');

  const { isAuthenticated, isLoading, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
  };

  if (isLoading) {
    return (
      <Center className="min-h-screen-safe">
        <Loader size="xl" />
      </Center>
    );
  }

  // Справка нужна и до входа: на странице входа есть своя статья, поэтому
  // провайдер обёрнут и вокруг публичных страниц. Без него кнопка «?» там
  // ничего не открывает, а F1 достаётся браузеру.
  if (!isAuthenticated) {
    return (
      <HelpProvider>
        <AppRoutes />
      </HelpProvider>
    );
  }

  // Провайдер справки обёрнут вокруг всего рабочего контура: панель живёт выше
  // маршрутов, поэтому при переходе между экранами не закрывается, а F1
  // работает на любом экране.
  return (
    <HelpProvider>
    <div className="flex min-h-screen-safe h-screen bg-background">
      {!isMobile && (
        <aside
          className="flex-shrink-0 h-full"
          onMouseEnter={() => setSidebarHovered(true)}
          onMouseLeave={() => setSidebarHovered(false)}
        >
          <NavbarComponent
            expanded={sidebarExpanded}
            pinnedExpanded={navbarPinnedOpen}
            onToggleCollapse={toggleNavbarPinned}
            onLogout={handleLogout}
          />
        </aside>
      )}

      {isMobile && (
        <>
          <button
            type="button"
            onClick={toggle}
            className="fixed top-4 left-4 z-50 flex h-11 w-11 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-lg hover:opacity-90 transition-opacity"
            aria-label="Открыть меню"
          >
            <Menu className="h-5 w-5" />
          </button>
          <DrawerMenu opened={opened} onClose={close} onLogout={handleLogout} />
        </>
      )}

      <main className="flex-1 min-w-0 overflow-x-hidden overflow-y-auto p-4 pt-16 pl-14 md:p-6 md:pt-6 md:pl-6">
        <AppRoutes />
      </main>
    </div>
    </HelpProvider>
  );
}
